var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Button from "../../buttonComponent/button";
import Modal from "../../modal/modal";
import { _ } from "../../../utils";
var LoginExpiryModal = /** @class */ (function (_super) {
    __extends(LoginExpiryModal, _super);
    function LoginExpiryModal(props) {
        var _this = _super.call(this, props) || this;
        _this.messageReciever = function (event) {
            var data = event.data;
            var popup = _this.state.popup;
            var hideModal = _this.props.hideModal;
            if (data.loginSuccess) {
                popup && popup.close();
                hideModal();
            }
        };
        _this.launchSSO = function () {
            var _a = _this.props.params, baseURL = _a.baseURL, redirectRoute = _a.redirectRoute;
            var popup = window.open((baseURL
                ? baseURL
                : window.location.protocol + "//" + window.location.host) + "/login?next=" + (redirectRoute ? redirectRoute : "/resume"), "popUpWindow", "height=700,width=700,left=50,top=50,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,directories=no, status=yes");
            _this.setState({
                popup: popup,
            });
        };
        _this.state = {
            popup: null,
        };
        return _this;
    }
    LoginExpiryModal.prototype.componentDidMount = function () {
        window.addEventListener("message", this.messageReciever, false);
    };
    LoginExpiryModal.prototype.componentWillUnmount = function () {
        var hideModal = this.props.hideModal;
        hideModal();
        window.removeEventListener("message", this.messageReciever);
    };
    LoginExpiryModal.prototype.render = function () {
        var _a = this.props, visible = _a.visible, params = _a.params, hideModal = _a.hideModal;
        return (React.createElement(Modal, { visible: visible, title: _.get(params, "title", "Session Expired"), footer: null, closable: params.closable || false, centered: true, onCancel: hideModal, maskClosable: false, style: params.bodyStyle, className: params.className, maskStyle: __assign({}, params.maskStyle) },
            React.createElement("div", { className: "body-text", style: { marginBottom: "2em" } }, _.get(params, "description", "You need to login again to continue.")),
            React.createElement("div", { className: "login-button" },
                React.createElement(Button, __assign({ btnType: "primary", title: "Login", onClick: this.launchSSO, style: { margin: 0 } }, params.btnProps)))));
    };
    return LoginExpiryModal;
}(React.Component));
export default LoginExpiryModal;
//# sourceMappingURL=loginExpiryModal.js.map